// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.updatepermissiondialog_featuredItem__-F7l1 {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.updatepermissiondialog_dialogInputs__UnRAK {
    width: 100%;
}

.updatepermissiondialog_featuredTitleHeader__H1CEv {
    color: var(--hsrcDarkBlue);
    font-size: 16px;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/PermissionsManagement/UpdatePermissionDialog/updatepermissiondialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredItem": `updatepermissiondialog_featuredItem__-F7l1`,
	"dialogInputs": `updatepermissiondialog_dialogInputs__UnRAK`,
	"featuredTitleHeader": `updatepermissiondialog_featuredTitleHeader__H1CEv`
};
export default ___CSS_LOADER_EXPORT___;
